import { createFileRoute } from "@tanstack/react-router";
import {
  bounceToAccountPath,
  haltForExternalNavigation,
} from "../lib/auth/app-origins";

/** Auth UI now lives on account-web — bounce old /reset-password bookmarks. */
export const Route = createFileRoute("/reset-password")({
  beforeLoad: () => {
    if (typeof window !== "undefined") {
      bounceToAccountPath("/reset-password", window.location.search);
      haltForExternalNavigation();
    }
  },
  validateSearch: (search: Record<string, unknown>): { email?: string; token?: string } => ({
    email: typeof search.email === "string" ? search.email : undefined,
    token: typeof search.token === "string" ? search.token : undefined,
  }),
  component: () => null,
});
